import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
const BoardofDirectors = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/list-of-board-of-directors`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setData(response.data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token]);

    const downloadFile = (fileUrl, fileName) => {
        axios({
            url: fileUrl,
            method: "GET",
            responseType: "blob",
            headers: {
                'Authorization': `Bearer ${token}`
            },
        })
            .then((res) => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            })
            .catch((error) => {
                console.error("Download error:", error);
                // Handle download error (e.g., show notification to the user)
            });
    };

    return (
        <>
            <Navbar />
            <div>
                <h2>Board of Directors</h2>
                {loading && <p>Loading...</p>}
                {error && <p>Error: {error.message}</p>}
                <div>
                    {data.map((director) => (
                        <div key={director.id}>
                            <h3>{director.name}</h3>
                            {director.List_of_BODs && director.List_of_BODs.length > 0 ? (
                                <div>
                                    <p>PDF File Name: {director.List_of_BODs[0].name}</p>
                                    <button
                                        onClick={() =>
                                            downloadFile(
                                                `http://localhost:1337${director.List_of_BODs[0].url}`,
                                                director.List_of_BODs[0].name
                                            )
                                        }
                                    >
                                        Download File
                                    </button>
                                </div>
                            ) : (
                                <p>No PDF file available for download</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BoardofDirectors;
